import Dashboard from '../dashboard/Dashboard';

export default function Home() {
    return (
        <Dashboard/>        
    )
}